import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormLabel,
  Modal,
  Stack,
  TextField,
  Typography,
  IconButton,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState, useMemo } from "react";
import { style, initailState } from "../../Pages/JobTabDashboard";
import { useForm } from "react-hook-form";
import { createFilterOptions } from "@mui/material/Autocomplete";
import FileUpload from "react-material-file-upload";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useDispatch, useSelector } from "react-redux";
import img_not_found from "../../assets/img_not_found.jpg";
import { marked } from "marked";
import {
  getCountryData,
  getCountryName,
  getCityName,
} from "../../Redux/Country/action";
import ReuseableLabel from "../ReusableComponents/ReuseableLabel";
import { CkEditorComponent } from "../ReusableComponents/CkEditor";
import { privateAxiosInstance } from "../../utils/axiosInstance";
import { accessTokenHeadersObject } from "../../utils/headers";
import { environmentDetails } from "../../environment/environment";
import axios from "axios";
const apiUrl = environmentDetails.apiUrl;

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const filter = createFilterOptions();

// Responsive style for the modal container
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95vw", md: "80vw", lg: "70vw" },
  maxWidth: "1000px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 },
  borderRadius: "8px",
  maxHeight: "95vh",
  overflowY: "auto",
};

const EditJobRoleModal = ({
  open,
  setOpen,
  data,
  jobRoleEdit,
  image,
  setImage,
}) => {
  // All the logic (hooks, state, and functions) remains unchanged
  const dispatch = useDispatch();
  const [values, setValues] = useState([]);
  const [currValue, setCurrValue] = useState("");
  const [selected, setSelected] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCity, setSelectedCity] = useState([]);
  const [isDuplicateSkill, setIsDuplicateSkill] = useState(false);
  const [isEmptySkill, setIsEmptySkill] = useState(false);
  const [isEmptyLocation, setIsEmptyLocation] = useState(false);
  const [isEmptyCountry, setIsEmptyCountry] = useState(false);
  const [isEmptyCity, setIsEmptyCity] = useState(false);
  const [isEmptyRole, setIsEmptyRole] = useState(false);
  const [isEmptyDesc, setIsEmptyDesc] = useState(false);
  const [isEmptyImageFile, setIsEmptyImageFile] = useState(false);
  const [isEmptyCurrency, setIsEmptyCurrency] = useState(false);
  const [currencyId, setCurrencyId] = useState("");
  const [role, setRole] = useState([]);
  const [desc, setDesc] = useState([]);
  const [gptJson, setGptJson] = useState([]);
  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [jobOpeningId, setJobOpeningId] = useState("");
  const [language, setLanguage] = useState("Select a Language");

  const [updateData, setUpdateData] = useState(null);
  const [generateJobDescriptionError, setGenerateJobDescriptionError] =
    useState(false);
  const [generateJDImgError, setGenerateJDImgError] = useState(false);
  const [jdWords, setJdWords] = useState(100);

  const [validImgtype, setValidImgtype] = useState(-1);
  const [validImgsize, setValidImgsize] = useState(-1);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsEmptyLocation(false);
    setIsEmptyCountry(false);
    setIsEmptyCity(false);
    setIsEmptySkill(false);
    setIsEmptyRole(false);
    setIsEmptyDesc(false);
    setIsEmptyImageFile(false);
    setValues([]);
    setRole("");
    setImage([]);
    setJobOpeningId("");
    setDesc("");
    setGptJson("");
    setCurrValue("");
    setCurrencyId("");
    setValidImgtype(-1);
    setValidImgsize(-1);
    setGenerateJDImgError(false);
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: initailState,
  });

  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    // dispatch(getCountryName()).then((res) => {
    //   let data = Array.from(res.payload);
    //   let cc = data?.map((i) => i.country);
    //   setCountries(cc);
    // });
    dispatch(getCountryData()).then((res) => {
      //console.log(res.payload);
      // Changing the priority of the Country Data
      let countryDataForCountryFetch = res.payload;
      //console.log("countryDataForCountryFetch", countryDataForCountryFetch);
      let cc = countryDataForCountryFetch?.map((i) => i.name);
      //console.log("////////////////", cc);
      setCountries(cc);
    });
  }, []);

  /*useEffect(() => {
    if (selectedCountry != "") {
      dispatch(getCityName(selectedCountry.country)).then((res) => {
        if (res.payload) {
          setCities([...res?.payload?.data]);
        } else {
          setCities([data.cities]);
        }
      });
    }
  }, [selectedCountry]);*/
  useEffect(() => {
    if (!selectedCountry || selectedCountry === "" || selectedCountry === "null") {
      setCities([]);
      return;
    }
    dispatch(getCityName(selectedCountry.country))
      .then((res) => {
        if (res && res.length > 0) {
          setCities([...res]);
        } else {
          setCities(["Mumbai"]);
        }
      })
      .catch((err) => {
        setCities(["Mumbai"]);
      });
  }, [selectedCountry]);

  const cityOptions = useMemo(() => {
    if (!Array.isArray(cities)) return [];

    return cities.map((city, index) => ({
      id: `${city}-${index}`, // UNIQUE
      label: city,
    }));
  }, [cities]);

  const countryData = useSelector((state) => state.countryReducer.country);
  let countryObject = countryData.find((x) => x.id === currencyId);

  useEffect(() => {
    dispatch(getCountryData());
  }, []);

  useEffect(() => {
    reset(data);
    const values = data.skill;
    setValues(values);
    const locations = data?.location;
    setSelected(locations);
    /*const country = data.country;
    const cities = data?.cities;
    if (country) {
      setSelectedCity(
        cities?.map((city, index) => ({
          id: `${city}-${index}`,
          label: city,
        })) || [],
      );
      setSelectedCountry({ country: data.country });
    }*/
    const country = data.country;
    const cities = data?.cities?.length > 0 ? data.cities : ["Mumbai"];
    if (country) {
      setSelectedCity(
        cities?.map((city, index) => ({
          id: `${city}-${index}`,
          label: city,
        })) || [],
      );
      setSelectedCountry({ country: data.country });
    }
    setRole(data.role);
    setJobOpeningId(data?.jobOpeningId || data?.jobId || "");
    let jds = data?.desc || "";
    if (typeof jds === "string" && jds.startsWith('"') && jds.endsWith('"')) {
      jds = jds.slice(1, -1);
    }
    setDesc(jds);
    setJdWords(data?.words ? data?.words : 100);
    setYearsOfExperience(data.yearsOfExperience ? data.yearsOfExperience : "");
    if (data?.currency != "") {
      setIsEmptyCurrency(false);
      let currencyDetails = data.currency ? data.currency.id : "";
      setCurrencyId(currencyDetails);
    }
  }, [open]);

  var locationData = [];
  if (data.location != undefined) {
    data.location.forEach((locval, index) => {
      locationData.push({
        id: parseInt(index + 1),
        location: locval,
      });
    });
  }

  var selectedLocation;
  if (selected !== undefined) {
    selectedLocation = JSON.parse(JSON.stringify(selected));
  }

  const locationHandleChange = (event, value, reason) => {
    setSelected(value);
    if (value?.length === 0) {
      setIsEmptyLocation(true);
    } else {
      setIsEmptyLocation(false);
    }
  };

  const countryhandleChange = (event, value) => {
    if (value == null) {
      setIsEmptyCountry(true);
      setSelectedCountry("");
      setIsEmptyCity(true);
      setSelectedCity([]);
    } else {
      setIsEmptyCountry(false);
      setIsEmptyCity(true);
      setSelectedCity([]);
      if (typeof value === "string") setSelectedCountry({ country: value });
      else if (value && value?.inputValue)
        setSelectedCountry({ country: value.inputValue });
      else setSelectedCountry(value);
    }
  };

  // const cityhandleChange = (event, value) => {
  //   if (value == null) {
  //     setIsEmptyCity(true);
  //   } else {
  //     setSelectedCity(value?.map((val) => val));
  //     setIsEmptyCity(false);
  //   }
  // };
  const cityhandleChange = (event, value) => {
    setIsEmptyCity(!value || value.length === 0);
    setSelectedCity(value || []);
  };
  const handleFileUploaderOnChange = (data) => {
    if (data?.length === 0) {
      setIsEmptyImageFile(true);
      setImage(data);
    } else {
      const fileName = data[0].name;
      const extension = fileName.split(".").pop();
      const isSupported = ["png", "jpeg", "jpg"].includes(extension);
      const maxsize = 2 * 1024 * 1024;
      const filelimit = data[0].size < maxsize;
      if (isSupported && filelimit) {
        setValidImgtype(1);
        setValidImgsize(1);
        setIsEmptyImageFile(false);
        setImage(data);
      } else {
        if (!isSupported) setValidImgtype(0);
        if (!filelimit) setValidImgsize(0);
      }
    }
    setImage(data);
  };

  const handlePrettierDescription = () => {
    if (desc) {
      const plainTextDescription = new DOMParser().parseFromString(
        desc,
        "text/html",
      ).body.textContent;
      const bodyData = {
        prettier: true,
        jdDetails: plainTextDescription,
      };
      privateAxiosInstance
        .post(
          `/questionnaire/generateJobDescription?processName=Initiation_preScreeningProcess`,
          bodyData,
          {
            headers: { ...accessTokenHeadersObject() },
          },
        )
        .then((res) => {
          const html = marked(res.data.content);
          setDesc(html);
        })
        .catch((err) => {
          console.log("generate jd Err ", err);
        });
    }
  };

  const onSubmit = (editData) => {
    if (selected?.length === 0) {
      setIsEmptyLocation(true);
    }
    if (selectedCountry?.length === 0) {
      setIsEmptyCountry(true);
    }
    if (selectedCity?.length === 0) {
      setIsEmptyCity(true);
    }
    if (role?.length === 0) {
      setIsEmptyRole(true);
    }
    if (values?.length === 0) {
      setIsEmptySkill(true);
    }
    if (currencyId === "") {
      setIsEmptyCurrency(true);
    }
    if (
      role?.length === 0 ||
      desc?.length === 0 ||
      values?.length === 0 ||
      selectedCity?.length === 0 ||
      selectedCountry?.length === 0 ||
      !currencyId
    ) {
      return;
    }
    let imageFile = image[0];
    editData.image = imageFile;
    editData.desc = desc;
    editData.gptJson = gptJson;
    editData.jobOpeningId = jobOpeningId;
    editData.words = jdWords;

    const formData = new FormData();
    let newEditData = {
      ...editData,
      skill: values,
      country: selectedCountry.country,
      cities: selectedCity.map((el) => el.label),
      currency: countryObject || data?.currency,
      jobOpeningId: jobOpeningId,
      words: jdWords,
    };

    const jobId = newEditData.jobId
      ? newEditData.jobId
      : imageFile?.lastModified;

    Object.entries(newEditData).forEach(([key, value]) => {
      formData.append(key, value);
    });
    jobRoleEdit(jobId, newEditData);
  };

  const handleKeyUp = (e) => {
    let val = e.target.value.trim();
    let newValArr = values.map((i) => i.toLowerCase());
    if (
      !isDuplicateSkill &&
      e.keyCode == 188 &&
      val !== "" &&
      !newValArr.includes(val.toLowerCase())
    ) {
      setValues((oldState) => [...oldState, val]);
      setCurrValue("");
    } else {
      setIsDuplicateSkill(true);
    }
  };

  const handleChange = (e) => {
    let val = e.target.value.trim().toLowerCase();
    const lowerCaseArr = values.map((str) => str.trim().toLowerCase());
    setIsDuplicateSkill(lowerCaseArr.includes(val));
    if (values?.length === 0) {
      setIsEmptySkill(true);
    } else {
      setIsEmptySkill(false);
    }
    setCurrValue(e.target.value.replace(/,/g, ""));
  };

  const handleDelete = (item, index) => {
    let arr = [...values];
    arr.splice(index, 1);
    if (arr.length === 0) {
      setIsEmptySkill(true);
    } else {
      setIsEmptySkill(false);
    }
    setValues(arr);
  };

  const rolehandler = (event) => {
    let val = event.target.value.trim();
    setRole(val);
    if (val === "") {
      setIsEmptyRole(true);
    } else {
      setIsEmptyRole(false);
    }
  };

  const deschandler = (event) => {
    let val = event.target.value.trim();
    setDesc(val);
  };

  const googleTranslate = async (text, targetLang = "en") => {
    try {
      let bodyData = {
        language: targetLang,
        desc: text,
      };
      privateAxiosInstance
        .post(
          `/questionnaire/translateJobDescription?processName=Initiation_preScreeningProcess`,
          bodyData,
          {
            headers: { ...accessTokenHeadersObject() },
          },
        )
        .then((res) => {
          setDesc(res.data.content);
        });
    } catch (error) {
      console.error("Translation error:", error);
      return text;
    }
  };

  const handleTranslate = async (language) => {
    setLanguage(language);
    if (language) {
      const translatedText = await googleTranslate(desc, language);
    }
  };

  const ckEditorDescriptionChange = (event, editor) => {
    let val = editor?.getData();
    setDesc(val);
    if (!val) {
      setIsEmptyDesc(true);
    } else {
      setIsEmptyDesc(false);
    }
  };

  const currencyOnChange = (event, value) => {
    if (value === null) {
      setCurrencyId("");
      setIsEmptyCurrency(true);
    } else {
      setCurrencyId(value?.id);
      setIsEmptyCurrency(false);
    }
  };

  const handleGenerateJobDescription = () => {
    if (
      role?.length === 0 ||
      values?.length === 0 ||
      !yearsOfExperience ||
      selectedLocation?.length === 0
    ) {
      setGenerateJobDescriptionError(true);
      let timerId = setTimeout(() => {
        setGenerateJobDescriptionError(false);
      }, 4000);
      return;
    }

        const plainTextDescription = new DOMParser()
  .parseFromString(desc, "text/html")
  .body.textContent;

    const bodyData = {
      jobRole: role,
      skills: values,
      yearsOfExperience: yearsOfExperience,
      words: jdWords,
      country: selectedCountry.country,
      cities: selectedCity.map((el) => el.label),
      currency: JSON.stringify(countryObject),
      jdDetails : plainTextDescription
    };
    setRole(role);
    privateAxiosInstance
      .post(
        `/questionnaire/generateJobDescription?processName=Initiation_preScreeningProcess`,
        bodyData,
        {
          headers: { ...accessTokenHeadersObject() },
        },
      )
      .then((res) => {
         const html = marked(res.data.content);
                 console.log("html" , html)
            setDesc(html);
        // setDesc(res.data.content);
        setIsEmptyDesc(false);
        let newData = {
          ...data,
          role: role,
          yearsOfExperience: yearsOfExperience,
          skill: values.join(","),
          country: selectedCountry.country,
          cities: selectedCity.map((el) => el.label),
          currency: JSON.stringify(countryObject),
          desc: res.data.content,
        };
        setUpdateData(newData);
      })
      .catch((err) => {
        console.log("generate jd Err ", err);
      });
  };

  function removeQuotes(inputString) {
    const regex = /^"(.*)"$/;
    const match = regex.exec(inputString);
    if (match) {
      const contentWithinQuotes = match[1];
      return contentWithinQuotes;
    }
    return inputString;
  }

  useEffect(() => {
    if (updateData) {
      reset(updateData);
    }
  }, [updateData]);

  const getMinimumRequirementListFromRefData = async (iscat = true) => {
    const url = `${environmentDetails.refDateApi}cv_score/instances`;
    const params = { iscat: iscat.toString() };
    try {
      const response = await privateAxiosInstance.get(url, {
        headers: { ...accessTokenHeadersObject() },
      });
      console.log("success");
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.log("error");
      console.error("Error fetching CV score instances:", error.message);
      return {};
    }
  };

  function filterMinimumReqFieldsFromRefData(refData) {
    const keys = [];
    const dataArray = refData?.data || [];
    for (const item of dataArray) {
      if (item?.name) {
        keys.push(item.name);
      }
    }
    console.log("refdata", refData);
    console.log("keys", keys);
    return keys;
  }

  function createPromptOutputPayload(keys) {
    const output = {};
    keys.forEach((key) => {
      output[key] = "";
    });
    return output;
  }

  function extractJsonFromVisionResponse(rawString) {
    console.log("rawstring", rawString.data.data);
    try {
      const start = rawString.data.data.indexOf("{");
      const end = rawString.data.data.lastIndexOf("}") + 1;
      const jsonStr = rawString.data.data.substring(start, end);
      return JSON.parse(jsonStr);
    } catch (error) {
      console.error("JSON parsing failed:", error.message);
      return {};
    }
  }

  const generateJDImg = async () => {
    if (desc?.length <= 0) {
      setGenerateJDImgError(true);
      return;
    }

    const minimumRequirementList = await getMinimumRequirementListFromRefData();
    const minReqKeys = filterMinimumReqFieldsFromRefData(
      minimumRequirementList,
    );
    const outputTemplate = createPromptOutputPayload(minReqKeys);
    console.log("outputTemplate is", outputTemplate);

    const visionResponse = await axios.post(
      `${apiUrl}JD/extractMinimumRequirementFromJD`,
      {
        outputTemplate,
        jobDescription: desc,
      },
    );
    console.log("final json is in edit : ", visionResponse);
    console.log("description is", desc);

    if (visionResponse) {
      const finalJson = extractJsonFromVisionResponse(visionResponse);
      console.log(finalJson);
      console.log(
        "Final Extracted JSON:\n",
        JSON.stringify(finalJson, null, 2),
      );
      setGptJson(finalJson);
    }

    const data = {
      desc: removeQuotes(desc.replace(/<[^>]*>|[\r\n]|\\/g, "")),
      jobRole: role,
      yearsOfExperience: yearsOfExperience,
      skills: values,
    };
    console.log("checking the data in edit in chatgpt", data);
    privateAxiosInstance
      .post(
        "/questionnaire/generate-jdImage?processName=Initiation_preScreeningProcess",
        { ...data },
        {
          responseType: "arraybuffer",
          headers: { ...accessTokenHeadersObject() },
        },
      )
      .then((res) => {
        console.log("responceeeeeeee in edit", res);
        const blob = new Blob([res.data], { type: "image/png" });
        const imageFile = new File([blob], `jdImage${Date.now()}.png`, {
          type: "image/png",
        });
        console.log("image of js in edit: ", imageFile);
        setImage([imageFile]);
        setIsEmptyImageFile(false);
        setValidImgtype(1);
        setValidImgsize(1);
      })
      .catch((err) => {
        console.log("Error:", err);
        setValidImgtype(0);
        setValidImgsize(0);
      });
  };

  return (
    <div>
      <Modal open={open} aria-labelledby="edit-job-role-title">
        <Box sx={modalStyle}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box>
              <Typography
                id="edit-job-role-title"
                sx={{
                  fontSize: { xs: "24px", md: "30px" },
                  fontWeight: 600,
                  textAlign: "center",
                  mb: 2,
                  color: "primary.darkText",
                }}
              >
                Edit Job Role
              </Typography>
              <IconButton
                onClick={handleClose}
                sx={{ position: "absolute", top: 8, right: 8 }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>

              <Stack spacing={3}>
                {/* Job Role and ID */}
                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <TextField
                    fullWidth
                    label={<ReuseableLabel label={"Job Role"} />}
                    variant="outlined"
                    onKeyUp={rolehandler}
                    inputProps={{ maxLength: 30 }}
                    {...register("role")}
                    error={Boolean(isEmptyRole)}
                    helperText={isEmptyRole && "Job Role is required"}
                  />
                  <TextField
                    disabled
                    fullWidth
                    key="jobOpeningId"
                    label="Job Opening Id"
                    variant="outlined"
                    value={jobOpeningId || ""}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "gray !important",
                        color: "gray !important",
                      },
                    }}
                  />
                </Stack>

                {/* Years of Experience */}
                <TextField
                  fullWidth
                  label="Years of Experience"
                  variant="outlined"
                  {...register("yearsOfExperience")}
                  onChange={(e) => setYearsOfExperience(e.target.value)}
                />

                {/* Skills Input */}
                <FormControl fullWidth error={isEmptySkill}>
                  <FormLabel
                    sx={{
                      position: "absolute",
                      top: "-10px",
                      left: "10px",
                      bgcolor: "background.paper",
                      px: "4px",
                      fontSize: "0.75rem",
                    }}
                  >
                    <ReuseableLabel label={"Skills"} />
                  </FormLabel>
                  <Box
                    sx={{
                      border: 1,
                      borderColor: isEmptySkill ? "error.main" : "grey.400",
                      borderRadius: 1,
                      p: 1.5,
                      minHeight: "56px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                        mb: values?.length > 0 ? 1 : 0,
                      }}
                    >
                      {values?.map((item, index) => (
                        <Chip
                          size="small"
                          key={index}
                          onDelete={() => handleDelete(item, index)}
                          label={item}
                        />
                      ))}
                    </Box>
                    <TextField
                      variant="standard"
                      placeholder="Type a skill and press comma (,)"
                      value={currValue}
                      onChange={handleChange}
                      onKeyDown={handleKeyUp}
                      fullWidth
                      InputProps={{ disableUnderline: true }}
                      error={isDuplicateSkill}
                    />
                  </Box>
                  {(isDuplicateSkill || isEmptySkill) && (
                    <Typography
                      variant="caption"
                      color="error.main"
                      sx={{ ml: 2, mt: 0.5 }}
                    >
                      {isDuplicateSkill
                        ? `${currValue} already exists.`
                        : "At least one skill is required."}
                    </Typography>
                  )}
                </FormControl>

                {/* Country and City */}
                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <Autocomplete
                    fullWidth
                    options={countries || []}
                    value={selectedCountry||null}
                    onChange={countryhandleChange}
                    getOptionLabel={(option) => option.country || option || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<ReuseableLabel label={"Country"} />}
                        error={isEmptyCountry}
                        helperText={isEmptyCountry && "Country is required"}
                      />
                    )}
                  />
                  <Autocomplete
                    multiple
                    fullWidth
                    options={cityOptions}
                    value={selectedCity||null}
                    onChange={cityhandleChange}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.label}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<ReuseableLabel label="City" />}
                        error={isEmptyCity}
                        helperText={isEmptyCity && "City is required"}
                      />
                    )}
                  />
                </Stack>

                {/* Job Description Section */}
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      justifyContent: "space-between",
                      alignItems: { xs: "flex-start", md: "center" },
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                      Job Description
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        flexWrap: "wrap",
                      }}
                    >
                      <FormControl size="small">
                        <InputLabel>Translate</InputLabel>
                        <Select
                          value={language}
                          label="Translate"
                          onChange={(e) => handleTranslate(e.target.value)}
                        >
                          <MenuItem value="Select a Language" disabled>
                            Select Language
                          </MenuItem>
                          <MenuItem value="English">English</MenuItem>
                          <MenuItem value="Bengali">Bengali</MenuItem>
                          <MenuItem value="Hindi">Hindi</MenuItem>
                          <MenuItem value="Tamil">Tamil</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl size="small" sx={{ minWidth: 80 }}>
                        <InputLabel>Words</InputLabel>
                        <Select
                          value={jdWords}
                          label="Words"
                          onChange={(e) => setJdWords(e.target.value)}
                        >
                          <MenuItem value={100}>100</MenuItem>
                          <MenuItem value={150}>150</MenuItem>
                          <MenuItem value={200}>200</MenuItem>
                          <MenuItem value={250}>250</MenuItem>
                          <MenuItem value={300}>300</MenuItem>
                        </Select>
                      </FormControl>
                      <Button
                        onClick={handleGenerateJobDescription}
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none" }}
                      >
                        Generate JD
                      </Button>
                      <Button
                        onClick={handlePrettierDescription}
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none" }}
                      >
                        Prettier
                      </Button>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%", overflow: "hidden" }}>
                    <CkEditorComponent
                      ckEditorData={desc}
                      handleCkEditorChange={ckEditorDescriptionChange}
                    />
                    {isEmptyDesc && (
                      <Typography variant="caption" color="error.main">
                        Job Description is required.
                      </Typography>
                    )}
                    {generateJobDescriptionError && (
                      <Typography variant="caption" color="error.main">
                        Please fill Role, Skills, Experience, and Location to
                        generate a JD.
                      </Typography>
                    )}
                  </Box>
                </Box>

                {/* Image Upload and Preview */}
                <Button
                  size="small"
                  variant="contained"
                  onClick={generateJDImg}
                  sx={{ textTransform: "none" }}
                >
                  Generate Image
                </Button>
                <Stack
                  direction={{ xs: "column", md: "row" }}
                  spacing={2}
                  alignItems="center"
                >
                  <Box sx={{ width: "100%", flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mb: 1,
                      }}
                    ></Box>
                    <Box
                      sx={{
                        border:
                          isEmptyImageFile ||
                          validImgsize === 0 ||
                          validImgtype === 0
                            ? "1px solid red"
                            : "1px solid lightgray",
                        borderRadius: 1,
                        p: 0.5,
                      }}
                    >
                      <FileUpload
                        sx={{ height: "160px" }}
                        title={
                          validImgtype === 0
                            ? "Please upload image in .jpg, .jpeg, or .png format."
                            : validImgsize === 0
                              ? "File size exceeded (Max 2MB)."
                              : "Drag & drop image here, or click to select (JPG, PNG, JPEG | Max 2MB)"
                        }
                        value={image}
                        accept={"image/*,.jpg,.jpeg,.png"}
                        onChange={handleFileUploaderOnChange}
                      />
                    </Box>
                    {generateJDImgError && (
                      <Typography variant="caption" color="error.main">
                        Job description is required to generate an image.
                      </Typography>
                    )}
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "220px",
                      borderRadius: 1,
                      border: 2,
                      borderColor: "primary.main",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flex: 1,
                    }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      src={
                        image?.length
                          ? URL.createObjectURL(image[0])
                          : data.image || img_not_found
                      }
                      alt="Job Role Visual"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = img_not_found;
                      }}
                    />
                  </Box>
                </Stack>

                {/* Currency */}
                <Autocomplete
                  fullWidth
                  options={countryData}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  value={data.currency}
                  getOptionLabel={(option) =>
                    `${option.currency_symbol} : ${option.currency_name} [${option.currency}] [${option.name}]`
                  }
                  onChange={currencyOnChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<ReuseableLabel label={"Currency"} />}
                      error={isEmptyCurrency}
                      helperText={isEmptyCurrency && "Currency is required"}
                    />
                  )}
                />
              </Stack>

              {/* Action Buttons */}
              <Stack
                direction={{ xs: "column-reverse", sm: "row" }}
                justifyContent="flex-end"
                spacing={2}
                sx={{ width: "100%", mt: 4 }}
              >
                <Button
                  onClick={handleClose}
                  variant="contained"
                  color="secondary"
                  sx={{ textTransform: "none" }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ textTransform: "none" }}
                >
                  Save
                </Button>
              </Stack>
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default EditJobRoleModal;
